import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { payoutRequestService, type ResolvePayoutRequestPayload, type PaySessionsPayload } from '@/api/services/payoutRequestService'

export function usePayoutRequests(p?: Parameters<typeof payoutRequestService.list>[0]) {
  return useQuery({ queryKey: ['payout-requests', p], queryFn: () => payoutRequestService.list(p), staleTime: 15_000 })
}

export function useTrainerBreakdown(trainerId?: number, date?: string) {
  return useQuery({
    queryKey: ['payout-requests', 'breakdown', trainerId, date],
    queryFn: () => payoutRequestService.trainerBreakdown({ trainer_id: trainerId!, date }),
    enabled: !!trainerId,
    staleTime: 15_000,
  })
}

export function usePaySessions() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: PaySessionsPayload) => payoutRequestService.paySessions(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['payout-requests', 'breakdown'] })
      qc.invalidateQueries({ queryKey: ['payouts'] }) // trainer list balances + history
    },
  })
}

export function useResolvePayoutRequest() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: ResolvePayoutRequestPayload) => payoutRequestService.resolve(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['payout-requests'] })
      // A resolved (approved) request records a real payout — refresh those too.
      qc.invalidateQueries({ queryKey: ['payouts'] })
    },
  })
}
